import clsx from 'clsx';

import { Container } from '@src/ui/components/Container';

import Header from '../components/Header/Header';
import ArrowCircleLeftIcon from '../components/Icons/ArrowCircleLeftIcon';
import { LinkButton } from '../components/LinkButton';
import { LoaderProgress } from '../components/LoaderProgress';
import Trustbar from '../components/Trustbar/Trustbar';

export interface AuthLayoutProps {
    title?: string;
    subTitle?: any;
    className?: string;
    loading?: boolean;
    backButton?: boolean;
    children: any;
    setConfirmView?: (value: boolean) => void;
}

const AuthLayout = ({
    title,
    subTitle,
    className,
    loading,
    backButton,
    children,
    setConfirmView,
}: AuthLayoutProps) => {
    return (
        <>
            <Header />

            <Trustbar />

            <Container
                variant='wider'
                className={clsx(
                    className,
                    'grid grid-cols-1 text-body mb-12 mt-20',
                )}
            >
                <div className='mx-4 xl:mx-0 h-full'>
                    {backButton && (
                        <div
                            className='flex items-center cursor-pointer'
                            onClick={() => setConfirmView?.(false)}
                        >
                            <ArrowCircleLeftIcon />
                            <LinkButton
                                noHoverChange={true}
                                className='pr-4 w-0 lg:w-48 text-steel-60 ml-0.5'
                            >
                                Back
                            </LinkButton>
                        </div>
                    )}
                    {title && (
                        <div
                            className={
                                'font-sora-bold text-4xl mx-4 sm:mx-auto lg:mx-auto mb-6 max-w-lg text-center'
                            }
                        >
                            {title}
                        </div>
                    )}

                    {subTitle && (
                        <div
                            className={
                                'font-light text-body text-center mx-auto mb-4 max-w-lg'
                            }
                        >
                            {subTitle}
                        </div>
                    )}

                    <Container variant={'extraThin'}>
                        <div className='mx-4 sm:mx-24 md:mx-24 lg:mx-24 xl:mx-24'>
                            {children}
                        </div>
                    </Container>

                    <LoaderProgress fullScreen loading={loading} />
                </div>
            </Container>
        </>
    );
};

export default AuthLayout;
